import { createSelector } from '@reduxjs/toolkit';
import { AlertState } from './alertSlice';

export const getRoot = (state: {alert: AlertState}) => state.alert as AlertState;

export const getAlerts = createSelector(
  [getRoot],
  (state) => state.alerts,
);